import { decode, Signature } from 'jws'

export default function getPayloadOfToken(token: string): Signature['payload'] {
  const jwtData = decode(token)
  let payload = {}
  if (jwtData && jwtData.payload) {
    try {
      payload = JSON.parse(jwtData.payload)
    } catch (e) {
      payload = jwtData.payload
    }
  }
  return payload
}
